"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadVideoRemidersEmailState = void 0;
var UploadVideoRemidersEmailState;
(function (UploadVideoRemidersEmailState) {
    UploadVideoRemidersEmailState["None"] = "none";
    UploadVideoRemidersEmailState["OneDayAfter"] = "one-day-after-reminder-sent";
    UploadVideoRemidersEmailState["ThreeDaysAfter"] = "three-days-after-reminder-sent";
    UploadVideoRemidersEmailState["FiveDaysAfter"] = "five-days-after-reminder-sent";
    UploadVideoRemidersEmailState["OneWeekAfter"] = "one-week-after-reminder-sent";
    UploadVideoRemidersEmailState["TwoWeekAfter"] = "two-week-after-reminder-sent";
    UploadVideoRemidersEmailState["ThreeWeekAfter"] = "three-week-after-reminder-sent";
})(UploadVideoRemidersEmailState = exports.UploadVideoRemidersEmailState || (exports.UploadVideoRemidersEmailState = {}));
//# sourceMappingURL=upload-video-reminder-email-state.js.map